<template>
  <div>
    <div class="pb-1 border-bottom">
      <div class="row">
        <div class="col-4 font-weight-bold">Edgework</div>
        <div class="col-8">
          <span class="float-right">
            <FormButton class="btn-default btn-xxs" @click="selectAll">All Round</FormButton>
            <FormButton class="btn-default btn-xxs ml-1" @click="clearAll">Clear</FormButton>
          </span>
        </div>
      </div>
    </div>

    <div class="row edgework-area mt-1">
      <div class="col-4 col-form-label">Short A</div>
      <div class="col-2 pl-0"><FormCheckbox :value="isFlagSelected(OrderItemEdgeworkTypes.shortA)" @change="updateFlag(OrderItemEdgeworkTypes.shortA, $event)" /></div>
      <div class="col-4 col-form-label">Short B</div>
      <div class="col-2 pl-0"><FormCheckbox :value="isFlagSelected(OrderItemEdgeworkTypes.shortB)" @change="updateFlag(OrderItemEdgeworkTypes.shortB, $event)" /></div>
    </div>
    <div class="row edgework-area">
      <div class="col-4 col-form-label">Long A</div>
      <div class="col-2 pl-0"><FormCheckbox :value="isFlagSelected(OrderItemEdgeworkTypes.longA)" @change="updateFlag(OrderItemEdgeworkTypes.longA, $event)" /></div>
      <div class="col-4 col-form-label">Long B</div>
      <div class="col-2 pl-0"><FormCheckbox :value="isFlagSelected(OrderItemEdgeworkTypes.longB)" @change="updateFlag(OrderItemEdgeworkTypes.longB, $event)" /></div>
    </div>
    <small class="text-muted">Edges: {{description}}</small>
  </div>
</template>

<style scoped>
.edgework-area {
  font-size: 0.7rem;
}
</style>

<script>
import _ from 'lodash'
import { InventoryStockTypes, UOMTypes, OrderItemEdgeworkTypes, OrderItemEdgeworkTypeLookup } from '@/store/types'

export default {
  name: 'EdgeworkSelection',
  model: {
    event: 'update'
  },
  props: {
    value: Array
  },
  data() {
    return {
      flagList: _.clone(this.$props.value)
    }
  },
  watch: {
    value: function(newValue) {
      this.flagList = _.clone(newValue || [])
    }
  },
  computed: {
    description() {
      if(this.flagList.length == 0)
        return 'None'
      else if(this.flagList.length == 4)
        return 'All round'
      else {
        let shortCount = this.flagList.filter(flag => flag == OrderItemEdgeworkTypes.shortA || flag == OrderItemEdgeworkTypes.shortB).length
        let longCount = this.flagList.filter(flag => flag == OrderItemEdgeworkTypes.longA || flag == OrderItemEdgeworkTypes.longB).length

        var labels = []
        if(shortCount > 0)
          labels.push(`${shortCount} Short`)
        if(longCount > 0)
          labels.push(`${longCount} Long`)
        return labels.join(', ')
      }
    }
  },
  created() {
    this.OrderItemEdgeworkTypes = OrderItemEdgeworkTypes
    this.OrderItemEdgeworkTypeLookup = OrderItemEdgeworkTypeLookup
  },
  methods: {
    selectAll() {
      this.flagList = [OrderItemEdgeworkTypes.shortA, OrderItemEdgeworkTypes.shortB, OrderItemEdgeworkTypes.longA, OrderItemEdgeworkTypes.longB]
    },
    clearAll() {
      this.flagList = []
    },
    isFlagSelected(flag) {
      return this.flagList.indexOf(flag) != -1
    },
    updateFlag(flag, value) {
      if(value) {
        if(!this.isFlagSelected(flag)) {
          this.flagList.push(flag)
        }
      } else {
        if(this.isFlagSelected(flag)) {
          this.flagList.splice(this.flagList.indexOf(flag), 1) 
        }
      }
      this.$emit('update', this.flagList)
    }
  }
}
</script>